(function() {
  var throttle = function(type, name, obj) {
    obj = obj || $(window);
    var running = false;
    var func = function() {
      if (running) { return; }
      running = true;
      requestAnimationFrame(function() {
        obj.trigger(name);
        running = false;
      });
    };
    obj.on(type, func);
  };

  /* init - you can init any event */
  throttle("resize", "throttledResize");
})();


(function($) {

  var $nav    = $('#siteNav'),
      $navbar = $nav.parents('.navbar');

  // On open: add classes
  $nav.on('shown.bs.collapse', function() {
    $navbar.addClass('is-opened navbar-fixed-top');
    $('.banner').find('.container').addClass('navbar-fixed');
  });

  // On close: remove classes
  $nav.on('hidden.bs.collapse', function() {
    $navbar.removeClass('is-opened navbar-fixed-top');
    $('.banner').find('.container').removeClass('navbar-fixed');
  });

  // Close navbar on click outside of it
  $('html').on('click', function(event) {
    if ( $navbar.hasClass('is-opened') && !$(event.target).is('#siteNav, #siteNav *') ) {
      event.preventDefault();
      $nav.collapse('hide');
    }
  });

  var viewport = ResponsiveBootstrapToolkit;
  $(window).on('throttledResize', function() {
    if ( !viewport.is('>md') ) {
      $navbar.removeClass('is-opened navbar-fixed-top');
      $('.banner').find('.container').removeClass('navbar-fixed');
    }
  });

})(jQuery);
